import { Types } from "@grandvisionhq/graphql";
import { isGroupedOptin } from "../../types.js";
function ungroupOptIns(optIns) {
  return optIns.flatMap((curr) => isGroupedOptin(curr) ? curr.groupedOptIns : curr);
}
function omitGroupedOptIns(optIns) {
  return optIns.filter((optIn) => !isGroupedOptin(optIn));
}
const formatOptIns = (availableOptIns, selectedOptIns, getLabel) => {
  const formatOptInsWithSelection = (availableOptIns2, selectedOptIns2) => {
    const ungroupedAvailableOptins = ungroupOptIns(availableOptIns2);
    const ungroupedSelectedOptins = ungroupOptIns(selectedOptIns2);
    return ungroupedAvailableOptins.map((optIn) => ({
      ...optIn,
      isSelected: ungroupedSelectedOptins.some((s) => optIn.value === s.value)
    }));
  };
  const formatOptIn = (input) => ({
    id: input.value,
    uiType: Types.UIType.CHECKBOX,
    value: input.isSelected
  });
  return formatOptInsWithSelection(availableOptIns, selectedOptIns).map((optin) => ({
    literalText: getLabel(optin.titleKey),
    ...formatOptIn(optin)
  }));
};
export {
  formatOptIns,
  omitGroupedOptIns,
  ungroupOptIns
};
//# sourceMappingURL=grouped-opt-ins.js.map
